export default function DefaultFileLogo({
    style,
}) {
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M14.6422 22H7.94595C5.73681 22 3.94595 20.2091 3.94595 18V7C3.94595 4.79086 5.73681 3 7.94595 3H15C17.2091 3 19 4.79086 19 7V17.6423L14.6422 22L14.6423 17.8763C14.6423 17.8765 14.6423 17.8762 14.6423 17.8763L14.6422 22ZM13.6422 21V17.8768C13.6422 17.195 14.195 16.6423 14.8768 16.6423H18V7C18 5.34314 16.6568 4 15 4H7.94595C6.28909 4 4.94595 5.34314 4.94595 7V18C4.94595 19.6569 6.28909 21 7.94595 21H13.6422ZM16.5858 18.6423H15.6423V19.5858L16.5858 18.6423Z" fill="#536987"/>
    </svg>

}